import React from "react";
import { injectIntl, FormattedMessage } from "react-intl";
import SuccessIndicatorCard from "../../success-indicator-card";
import messages from "./account-removed-indicator-messages";

const AccountRemovedIndicator = ({ intl: { formatMessage } }) => (
  <SuccessIndicatorCard title={formatMessage(messages.accountRemoved)}>
    <FormattedMessage {...messages.dataWillBeDeletedSoon} />
  </SuccessIndicatorCard>
);

export { AccountRemovedIndicator };
export default injectIntl(AccountRemovedIndicator);
